/**
 * DevExtreme (esm/viz/range_selector.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import RangeSelector from "./range_selector/range_selector";
export default RangeSelector;
